// PuntoDeVentaProducto.tsx — Co Marca — POS Venta de Cafetería (con ModalPagoCafeteria)
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
    ShoppingBag, Search, Plus, X, CreditCard,
    CheckCircle, Users, Minus, ImageOff, Loader2, SquarePen, FileText, Receipt
} from 'lucide-react';
import Modal from '../../../components/Modal/Modal';
import ClientePOSModal from '../../../components/posCita/ClientePOSModal';
import ModalPagoCafeteria, { DatosPago } from './ModalPagoCafeteria';
import {
    fetchCategoriasProducto, CategoriaProducto
} from '../../../services/categoriaProductoService';
import {
    fetchProductosCafeteria, ProductoCafeteria
} from '../../../services/productoCafeteriaService';
import {
    createVentaCafeteria, VentaCafeteriaFormData, VentaCafeteria
} from '../../../services/ventaCafeteriaService';
import { SesionActivaResponse } from '../../../services/pos/sesionPOSService';
import { PuntoDeVenta } from '../../../services/pos/puntoDeVentaService';
import {
    fetchClientes, Cliente
} from '../../../services/citasService';
import { TipoPago } from '../../../services/tiposPagoService';
import { useAuth } from '../../../context/AuthContext';
import { useSessionExpiration } from '../../../hooks/useSessionExpiration';
import ExpiredSessionModal from '../../../components/Expired/ExpiredSessionModal';

import { Link } from 'react-router-dom';
import FacturaCafeteria from './FacturaCafeteria';

const C = {
    primary: '#FF2052',
    primaryDark: '#9B004A',
    secondary: '#007FC8',
    secondaryDark: '#004d7a',
    secondaryLight: '#00DBB9',
    accentDark: '#EC8400',
};

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800;900&display=swap');
.pprod * { font-family:'DM Sans',sans-serif !important; box-sizing:border-box; }
@keyframes ncpSpin { to{transform:rotate(360deg);} }
@keyframes ncpFadeUp { from{opacity:0;transform:translateY(12px);}to{opacity:1;transform:translateY(0);} }
@keyframes ncpPulse { 0%,100%{opacity:1;}50%{opacity:.5;} }

.ncp-scroll::-webkit-scrollbar{width:5px;height:5px;}
.ncp-scroll::-webkit-scrollbar-track{background:transparent;}
.ncp-scroll::-webkit-scrollbar-thumb{background:rgba(0,127,200,.25);border-radius:10px;}
.ncp-scroll::-webkit-scrollbar-thumb:hover{background:rgba(0,127,200,.45);}

.ncp-sel-card {
  border-radius:18px; border:2px solid #f1f5f9; background:#fff;
  cursor:pointer; overflow:hidden; transition:all .3s cubic-bezier(.16,1,.3,1);
  position:relative;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.ncp-sel-card:hover { border-color:${C.secondary}50; box-shadow:0 12px 40px rgba(0,127,200,.12); transform:translateY(-3px); }
.ncp-sel-card.active { border-color:${C.secondary}; box-shadow:0 12px 40px rgba(0,127,200,.2); }

.ncp-client-card {
  border-radius:14px; border:1.5px solid #f1f5f9;
  padding:14px 16px; cursor:pointer; transition:all .25s cubic-bezier(.16,1,.3,1);
  background:#fff;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.ncp-client-card:hover { border-color:${C.secondary}35; background:${C.secondary}05; }
.ncp-client-card.selected { border-color:${C.secondary}; background:${C.secondary}08; }

.ncp-input { transition:all .2s; }
.ncp-input:focus { outline:3px solid transparent; border-color:${C.secondary} !important; box-shadow:0 0 0 3px ${C.secondary}14; }
.ncp-input:focus-visible { outline:3px solid #fbbf24; outline-offset:1px; }

.ncp-confirm-btn {
  width:100%; padding:14px; border-radius:14px; border:none;
  font-size:.92rem; font-weight:800; display:flex; align-items:center; justify-content:center; gap:8px;
  transition:all .25s cubic-bezier(.16,1,.3,1); cursor:pointer;
}
.ncp-confirm-btn.ready {
  background:linear-gradient(135deg,${C.secondary},${C.secondaryDark});
  color:#fff; box-shadow:0 4px 18px ${C.secondary}35;
}
.ncp-confirm-btn.ready:hover { transform:translateY(-2px); box-shadow:0 8px 28px ${C.secondary}45; }
.ncp-confirm-btn.disabled { background:#f1f5f9; color:#cbd5e1; cursor:not-allowed; }

.ncp-tab { flex:1; padding:14px 8px; font-size:.82rem; font-weight:700; border:none; cursor:pointer; transition:all .2s; display:flex;align-items:center;justify-content:center;gap:6px; background:transparent; }
.ncp-tab.active { background:#fff; color:${C.secondary}; box-shadow:inset 0 -2px 0 ${C.secondary}; }
.ncp-tab.inactive { background:#fafafa; color:#94a3b8; }
.ncp-tab.inactive:hover { background:#f1f5f9; color:#64748b; }
.ncp-tab:focus-visible,.ncp-confirm-btn:focus-visible,button:focus-visible,.ncp-sel-card:focus-visible,.ncp-client-card:focus-visible,[role="button"]:focus-visible { outline:3px solid #fbbf24; outline-offset:2px; }

button, .ncp-confirm-btn, .ncp-tab, .ncp-sel-card, .ncp-client-card {
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}
.pprod-main-panel,.pprod-side-panel{min-width:0;}
@media(max-width:900px){
  .pprod-shell{height:auto !important;min-height:100%;flex-direction:column;padding:10px;gap:10px;overflow:visible !important;}
  .pprod-main-panel{order:2;margin:0 !important;overflow:visible !important;width:100%;}
  .pprod-main-scroll{overflow:visible !important;padding:18px !important;}
  .pprod-side-panel{order:1;width:100% !important;margin:0 !important;max-height:48dvh;min-height:260px;}
}
@media(max-width:560px){
  .pprod-shell{padding:7px;}
  .pprod-main-scroll{padding:14px !important;}
  .pprod-product-grid{grid-template-columns:1fr !important;}
  .pprod-side-panel{max-height:54dvh;border-radius:16px !important;}
  .ncp-client-card{padding:12px 13px;}
}
`;

const formatter = new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtMonto = (v: number) => formatter.format(v);

interface CartItem {
    producto: ProductoCafeteria;
    cantidad: number;
    montoDescuento: number;
}

const activateWithKeyboard = (event: React.KeyboardEvent<HTMLElement>, action: () => void) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        action();
    }
};

interface PuntoDeVentaProductoProps {
    sesionActiva?: SesionActivaResponse;
    puntoDeVenta?: PuntoDeVenta;
    /**
     * Grant del operador identificado por PIN sobre la caja. El backend lo
     * exige para toda venta de cafetería y atribuye el asiento de caja a ese
     * operador; sin grant el cobro se bloquea en la UI.
     */
    operadorToken?: string | null;
}

const PuntoDeVentaProducto: React.FC<PuntoDeVentaProductoProps> = ({ sesionActiva: sesionActivaProp, puntoDeVenta: puntoDeVentaProp, operadorToken = null }) => {
    const { logout } = useAuth();
    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();

    const [sesionActiva, setSesionActiva] = useState<SesionActivaResponse | null>(null);
    const [puntoDeVenta, setPuntoDeVenta] = useState<PuntoDeVenta | null>(null);
    const [cargandoSesion, setCargandoSesion] = useState(true);

    const [categorias, setCategorias] = useState<CategoriaProducto[]>([]);
    const [cargandoCategorias, setCargandoCategorias] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<CategoriaProducto | null>(null);
    const [products, setProducts] = useState<ProductoCafeteria[]>([]);
    const [cargandoProductos, setCargandoProductos] = useState(false);
    const [cart, setCart] = useState<CartItem[]>([]);

    const [clientes, setClientes] = useState<Cliente[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [clienteId, setClienteId] = useState<number | null>(null);
    const [showClientModal, setShowClientModal] = useState(false);
    const [clienteEditar, setClienteEditar] = useState<Cliente | null>(null);

    const [tiposPago, setTiposPago] = useState<TipoPago[]>([]);
    const [showPagoModal, setShowPagoModal] = useState(false);
    const cobrandoRef = useRef(false);
    const [cobrando, setCobrando] = useState(false);
    const [ventaCreada, setVentaCreada] = useState<VentaCafeteria | null>(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const [activeLeftTab, setActiveLeftTab] = useState<'products' | 'cart'>('products');
    const [activeRightTab, setActiveRightTab] = useState<'clients' | 'summary'>('clients');

    // Tipo de comprobante (factura / recibo)
    const [tipoComprobante, setTipoComprobante] = useState<'factura' | 'recibo'>('recibo');

    // Búsqueda de productos
    const [productSearchTerm, setProductSearchTerm] = useState('');

    // ── Función para refrescar productos manteniendo la categoría seleccionada ──
    const refreshProducts = useCallback(async (silent: boolean = false) => {
        if (!puntoDeVenta) return;
        if (!silent) setCargandoProductos(true);
        try {
            const params: any = {
                sucursal_id: puntoDeVenta.sucursal,
                activo: true,
            };
            if (selectedCategory) {
                params.categoria_id = selectedCategory.id;
            }
            const data = await fetchProductosCafeteria(params);
            setProducts(data);
        } catch (error) {
            /* Browser diagnostics omitted. */
        } finally {
            if (!silent) setCargandoProductos(false);
        }
    }, [puntoDeVenta, selectedCategory]);

    // ── Sesión: EXCLUSIVAMENTE la del POSContext (props) ──
    // La caja explícita y el grant del operador vienen del contexto POS
    // (NuevaCitaPage). No existe modo "standalone": con varias cajas abiertas
    // el endpoint singular responde 409 y elegir "una caja cualquiera" sería
    // atribuir ventas a una caja no elegida por el operador. Sin props el
    // módulo queda bloqueado (nunca elige por sí mismo).
    useEffect(() => {
        if (sesionActivaProp && puntoDeVentaProp) {
            setSesionActiva(sesionActivaProp);
            setPuntoDeVenta(puntoDeVentaProp);
            setTiposPago(puntoDeVentaProp.tipos_pago_permitidos_info || []);
        } else {
            setSesionActiva(null);
            setPuntoDeVenta(null);
            setTiposPago([]);
        }
        setCargandoSesion(false);
    }, [sesionActivaProp, puntoDeVentaProp]);

    // ── Categorías ──
    useEffect(() => {
        if (!puntoDeVenta) return;
        setCargandoCategorias(true);
        fetchCategoriasProducto(puntoDeVenta.sucursal)
            .then(data => setCategorias(data.filter(c => c.activo)))
            .catch((() => undefined))
            .finally(() => setCargandoCategorias(false));
    }, [puntoDeVenta]);

    // ── Productos (carga inicial y cuando cambia categoría) ──
    useEffect(() => {
        refreshProducts(false);
    }, [refreshProducts]);

    // ── Refrescar al cambiar a la pestaña "Productos" ──
    useEffect(() => {
        if (activeLeftTab === 'products') {
            refreshProducts(false);
        }
    }, [activeLeftTab, refreshProducts]);

    // ── Clientes ──
    useEffect(() => {
        fetchClientes().then(data => setClientes(data.sort((a, b) => a.id - b.id))).catch((() => undefined));
    }, []);

    const filteredClients = clientes.filter(c => {
        const s = searchTerm.toLowerCase();
        return c.usuario?.first_name?.toLowerCase().includes(s) ||
            c.usuario?.last_name?.toLowerCase().includes(s) ||
            c.usuario?.email?.toLowerCase().includes(s) ||
            c.ci_nit?.toLowerCase().includes(s) ||
            c.telefono?.toLowerCase().includes(s);
    });

    // ── Carrito ──
    const addToCart = (producto: ProductoCafeteria) => {
        setCart(prev => {
            const existing = prev.find(item => item.producto.id === producto.id);
            if (existing) {
                const newCant = existing.cantidad + 1;
                if (producto.controlar_stock && producto.stock !== null && newCant > producto.stock) return prev;
                return prev.map(item =>
                    item.producto.id === producto.id ? { ...item, cantidad: newCant } : item
                );
            } else {
                if (producto.controlar_stock && producto.stock !== null && 1 > producto.stock) return prev;
                return [...prev, { producto, cantidad: 1, montoDescuento: 0 }];
            }
        });
    };

    const updateCartItem = (productId: number, cantidad: number) => {
        if (cantidad <= 0) {
            setCart(prev => prev.filter(i => i.producto.id !== productId));
            return;
        }
        setCart(prev =>
            prev.map(i => {
                if (i.producto.id !== productId) return i;
                if (i.producto.controlar_stock && i.producto.stock !== null && cantidad > i.producto.stock) return i;
                return { ...i, cantidad, montoDescuento: Math.min(i.montoDescuento, Math.round(Number(i.producto.precio) * cantidad * 100) / 100) };
            })
        );
    };

    const removeFromCart = (productId: number) => {
        setCart(prev => prev.filter(i => i.producto.id !== productId));
    };

    const clearCart = () => setCart([]);

    // ── Totales ──
    const redondear = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;
    const subtotalBruto = redondear(cart.reduce((acc, item) => acc + Number(item.producto.precio) * item.cantidad, 0));
    const descuentoLineas = redondear(cart.reduce((acc, item) => acc + item.montoDescuento, 0));
    const subtotal = redondear(subtotalBruto - descuentoLineas);
    const updateLineDiscount = (id: number, value: string) => {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return;
        setCart(prev => prev.map(item => item.producto.id === id
            ? { ...item, montoDescuento: redondear(Math.max(0, Math.min(amount, Number(item.producto.precio) * item.cantidad))) }
            : item));
    };
    const [descuentoDirecto, setDescuentoDirecto] = useState<string>('');

    const handleDescuentoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let raw = e.target.value;
        if (raw === '') {
            setDescuentoDirecto('');
            return;
        }
        let num = parseFloat(raw);
        if (isNaN(num)) {
            setDescuentoDirecto('');
            return;
        }
        if (num < 0) num = 0;
        if (num > subtotal) num = subtotal;
        setDescuentoDirecto(num.toString());
    };

    const handleDescuentoBlur = () => {
        if (descuentoDirecto === '') return;
        let num = parseFloat(descuentoDirecto);
        if (isNaN(num)) {
            setDescuentoDirecto('');
            return;
        }
        if (num < 0) num = 0;
        if (num > subtotal) num = subtotal;
        setDescuentoDirecto(num.toString());
    };

    const descuentoNum = redondear(Math.min(subtotal, Math.max(0, Number(descuentoDirecto) || 0)));
    const total = redondear(Math.max(subtotal - descuentoNum, 0));

    // ── Habilitar cobro ──
    const isReadyToSell = cart.length > 0 && total > 0;

    // ── Reseteo del estado de venta ──
    const resetSaleState = () => {
        clearCart();
        setDescuentoDirecto('');
        setClienteId(null);
        setTipoComprobante('recibo');
        setActiveLeftTab('products');
        setActiveRightTab('clients');
    };

    // ── Cerrar modal de éxito y resetear ──
    const handleSuccessModalClose = () => {
        resetSaleState();
        setShowSuccessModal(false);
    };

    // ── Procesar pago desde el modal ──
    const handlePagoConfirmado = async (datosPago: DatosPago) => {
        if (!sesionActiva || cobrandoRef.current) return;
        setShowPagoModal(false);
        if (!operadorToken) { alert('Identifica al operador de caja con su PIN antes de cobrar.'); return; }
        cobrandoRef.current = true;
        setCobrando(true);
        try {
            const items = cart.map(i => ({ producto_id: i.producto.id, cantidad: i.cantidad, monto_descuento: i.montoDescuento.toFixed(2) }));
            const pago = {
                tipo_pago_id: datosPago.tipo_pago_id,
                monto: datosPago.monto.toFixed(2),
                efectivo_recibido: datosPago.efectivo_recibido?.toFixed(2),
            };
            const data: VentaCafeteriaFormData = {
                sesion_pos_id: sesionActiva.id,
                cliente: clienteId ? clientes.find(c => c.id === clienteId)?.usuario?.id : undefined,
                items,
                pago,
                observaciones: '',
                tipo_comprobante: tipoComprobante,
                descuento: descuentoNum,   // ← enviar descuento (número)
            };
            const venta = await createVentaCafeteria(data, operadorToken);
            setVentaCreada(venta);
            resetSaleState();
            setShowSuccessModal(true);
            void refreshProducts(true).catch((() => undefined));
        } catch (e: any) {
            const detail = e.response?.data;
            const msg = typeof detail === 'object' ? JSON.stringify(detail) : (detail || e.message);
            alert('Error al registrar la venta: ' + msg);
        } finally {
            cobrandoRef.current = false;
            setCobrando(false);
        }
    };

    const handleClienteGuardado = (cliente: Cliente) => {
        setClientes(prev => [...prev.filter(c => c.id !== cliente.id), cliente].sort((a, b) => a.id - b.id));
        setClienteId(cliente.id);
        setShowClientModal(false);
        setClienteEditar(null);
        setActiveRightTab('summary');
    };

    // Filtrado de productos
    const filteredProducts = products.filter(prod =>
        prod.nombre.toLowerCase().includes(productSearchTerm.toLowerCase())
    );

    if (cargandoSesion) return (
        <>
            <style>{css}</style>
            <div className="pprod" style={{ display: 'flex', height: '100%', background: '#fff', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '16px' }}>
                <div style={{ width: '40px', height: '40px', border: `3px solid ${C.secondary}`, borderTopColor: 'transparent', borderRadius: '50%', animation: 'ncpSpin .7s linear infinite' }} />
                <p style={{ color: '#64748b', fontWeight: '600', fontSize: '.9rem' }}>Cargando sesión POS...</p>
            </div>
        </>
    );
    if (!sesionActiva) return (
        <>
            <style>{css}</style>
            <div className="pprod" style={{ display: 'flex', height: '100%', background: '#fff', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '12px' }}>
                <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: `${C.primary}10`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <X size={24} color={C.primary} />
                </div>
                <p style={{ fontSize: '1.1rem', fontWeight: '900', color: '#0f172a' }}>Sin sesión POS activa</p>
                <p style={{ fontSize: '.85rem', color: '#64748b' }}>La cafetería solo opera desde la caja seleccionada en el POS: elige una caja abierta en la lista de puntos de venta.</p>
            </div>
        </>
    );

    return (
        <>
            <style>{css}</style>
            <div className="pprod pprod-shell ncp-scroll" style={{ display: 'flex', height: '100%', minHeight:0, background: '#f8fafc', overflowX: 'clip', fontFamily: "'DM Sans',sans-serif" }}>

                {/* COLUMNA IZQUIERDA - Productos / Carrito */}
                <div className="pprod-main-panel" style={{ flex: 1, display: 'flex', flexDirection: 'column', margin: '16px 0 16px 16px', borderRadius: '20px', background: '#fff', border: '1.5px solid #f1f5f9', boxShadow: '0 4px 24px rgba(0,0,0,.05)', overflow: 'hidden' }}>
                    <div style={{ display: 'flex', borderBottom: '1.5px solid #f1f5f9', flexShrink: 0 }}>
                        <button className={`ncp-tab ${activeLeftTab === 'products' ? 'active' : 'inactive'}`} onClick={() => setActiveLeftTab('products')}>
                            <ShoppingBag size={15} /> Productos
                        </button>
                        <button className={`ncp-tab ${activeLeftTab === 'cart' ? 'active' : 'inactive'}`} onClick={() => setActiveLeftTab('cart')}>
                            <CreditCard size={15} /> Carrito ({cart.length})
                        </button>
                    </div>
                    <div className="ncp-scroll pprod-main-scroll" style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
                        {activeLeftTab === 'products' && (
                            <div>
                                <div style={{ marginBottom: '24px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                                        <div>
                                            <p style={{ fontSize: '.72rem', fontWeight: '700', color: C.secondary, textTransform: 'uppercase', letterSpacing: '.1em', marginBottom: '8px' }}>Categorías</p>
                                            {cargandoCategorias ? (
                                                <div style={{ display: 'flex', justifyContent: 'center', padding: '8px' }}>
                                                    <Loader2 size={20} className="ncpSpin" color={C.secondary} />
                                                </div>
                                            ) : categorias.length === 0 ? (
                                                <div style={{ textAlign: 'center', padding: '12px', color: '#94a3b8', background: '#f8fafc', borderRadius: '10px' }}>
                                                    No hay categorías disponibles para esta sucursal.
                                                </div>
                                            ) : (
                                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                    <div role="button" tabIndex={0} aria-pressed={selectedCategory===null}
                                                        onClick={() => setSelectedCategory(null)} onKeyDown={event=>activateWithKeyboard(event,()=>setSelectedCategory(null))}
                                                        style={{
                                                            padding: '6px 14px', borderRadius: '100px', cursor: 'pointer',
                                                            border: `1.5px solid ${selectedCategory === null ? C.secondary : '#e2e8f0'}`,
                                                            background: selectedCategory === null ? `${C.secondary}10` : '#fff',
                                                            color: selectedCategory === null ? C.secondary : '#64748b',
                                                            fontSize: '.82rem', fontWeight: '700', transition: 'all .2s'
                                                        }}
                                                    >
                                                        Todas
                                                    </div>
                                                    {categorias.map(cat => (
                                                        <div role="button" tabIndex={0} aria-pressed={selectedCategory?.id===cat.id}
                                                            key={cat.id}
                                                            onClick={() => setSelectedCategory(selectedCategory?.id === cat.id ? null : cat)}
                                                            onKeyDown={event=>activateWithKeyboard(event,()=>setSelectedCategory(selectedCategory?.id===cat.id?null:cat))}
                                                            style={{
                                                                padding: '6px 14px', borderRadius: '100px', cursor: 'pointer',
                                                                border: `1.5px solid ${selectedCategory?.id === cat.id ? C.secondary : '#e2e8f0'}`,
                                                                background: selectedCategory?.id === cat.id ? `${C.secondary}10` : '#fff',
                                                                color: selectedCategory?.id === cat.id ? C.secondary : '#64748b',
                                                                fontSize: '.82rem', fontWeight: '700', transition: 'all .2s'
                                                            }}
                                                        >
                                                            {cat.nombre}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ position: 'relative', minWidth: '200px' }}>
                                            <Search size={13} color="#94a3b8" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                                            <input
                                                type="text"
                                                placeholder="Buscar producto..."
                                                value={productSearchTerm}
                                                onChange={e => setProductSearchTerm(e.target.value)}
                                                className="ncp-input"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 8px 8px 32px',
                                                    borderRadius: '40px',
                                                    border: '1.5px solid #e2e8f0',
                                                    background: '#fff',
                                                    fontSize: '.85rem',
                                                    color: '#0f172a'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 style={{ fontSize: '1.1rem', fontWeight: '900', color: '#0f172a', marginBottom: '16px' }}>
                                        {selectedCategory ? selectedCategory.nombre : 'Todos los productos'}
                                    </h2>
                                    {cargandoProductos ? (
                                        <div style={{ textAlign: 'center', padding: '32px' }}>
                                            <Loader2 size={28} className="ncpSpin" color={C.secondary} />
                                            <p style={{ color: '#64748b', fontSize: '.85rem', marginTop: '8px' }}>Cargando productos...</p>
                                        </div>
                                    ) : (
                                        <div className="pprod-product-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '14px' }}>
                                            {filteredProducts.map(prod => {
                                                const puedeAgregar = !prod.controlar_stock || (prod.stock !== null && prod.stock > 0);
                                                const cantidadEnCarrito = cart.find(item => item.producto.id === prod.id)?.cantidad || 0;
                                                return (
                                                    <div role="button" tabIndex={puedeAgregar?0:-1} aria-disabled={!puedeAgregar}
                                                        key={prod.id}
                                                        className="ncp-sel-card"
                                                        style={{ padding: '16px', display: 'flex', flexDirection: 'column', cursor: puedeAgregar ? 'pointer' : 'not-allowed', opacity: puedeAgregar ? 1 : 0.6, position: 'relative' }}
                                                        onClick={() => puedeAgregar && addToCart(prod)}
                                                        onKeyDown={event=>puedeAgregar&&activateWithKeyboard(event,()=>addToCart(prod))}
                                                    >
                                                        {cantidadEnCarrito > 0 && (
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: '8px',
                                                                right: '8px',
                                                                background: C.secondary,
                                                                color: '#fff',
                                                                borderRadius: '20px',
                                                                padding: '2px 8px',
                                                                fontSize: '.7rem',
                                                                fontWeight: '800',
                                                                boxShadow: '0 2px 6px rgba(0,0,0,.15)',
                                                                zIndex: 2
                                                            }}>
                                                                {cantidadEnCarrito}
                                                            </div>
                                                        )}
                                                        <div style={{ height: '120px', borderRadius: '12px', overflow: 'hidden', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
                                                            {prod.imagen ? (
                                                                <img src={prod.imagen} alt={prod.nombre} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                            ) : (
                                                                <ImageOff size={28} color="#cbd5e1" />
                                                            )}
                                                        </div>
                                                        <p style={{ fontSize: '.88rem', fontWeight: '700', color: '#0f172a', marginBottom: '4px' }}>{prod.nombre}</p>
                                                        <p style={{ fontSize: '.95rem', fontWeight: '900', color: C.secondary }}>{prod.precio} Bs.</p>
                                                        {prod.controlar_stock && (
                                                            <p style={{ fontSize: '.72rem', color: prod.stock && prod.stock > 0 ? '#065f46' : C.primaryDark, fontWeight: '600', marginTop: '4px' }}>
                                                                Stock: {prod.stock ?? 0}
                                                            </p>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                            {filteredProducts.length === 0 && (
                                                <p style={{ gridColumn: '1/-1', textAlign: 'center', color: '#94a3b8', padding: '32px' }}>
                                                    {productSearchTerm ? 'No hay productos que coincidan con la búsqueda' : 'No hay productos disponibles'}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {activeLeftTab === 'cart' && (
                            <div>
                                <h2 style={{ fontSize: '1.1rem', fontWeight: '900', color: '#0f172a', marginBottom: '16px' }}>Carrito de compra</h2>
                                {cart.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#94a3b8', padding: '32px' }}>No hay productos en el carrito</p>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {cart.map(({ producto, cantidad, montoDescuento }) => (
                                            <div key={producto.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', borderRadius: '12px', border: '1.5px solid #f1f5f9', background: '#fff' }}>
                                                <div style={{ width: '50px', height: '50px', borderRadius: '10px', overflow: 'hidden', flexShrink: 0 }}>
                                                    {producto.imagen ? <img src={producto.imagen} alt={producto.nombre} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <ImageOff size={20} color="#cbd5e1" />}
                                                </div>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <p style={{ fontSize: '.88rem', fontWeight: '700', color: '#0f172a' }}>{producto.nombre}</p>
                                                    <p style={{ fontSize: '.78rem', color: '#64748b' }}>{producto.precio} Bs. c/u</p>
                                                    <label style={{ display: 'block', fontSize: '.75rem', marginTop: 8 }}>Descuento de línea (Bs.)
                                                        <input type="number" aria-label={`Descuento de ${producto.nombre}`} min="0" max={Number(producto.precio) * cantidad} step="0.01"
                                                            value={montoDescuento || ''} disabled={cobrando} className="ncp-input"
                                                            onChange={e => updateLineDiscount(producto.id, e.target.value)}
                                                            style={{ display: 'block', width: 100, padding: 6, border: '1px solid #e2e8f0', borderRadius: 6 }} />
                                                    </label>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <button onClick={() => updateCartItem(producto.id, cantidad - 1)} style={{ width: '28px', height: '28px', borderRadius: '6px', border: '1.5px solid #e2e8f0', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                                        <Minus size={12} />
                                                    </button>
                                                    <span style={{ fontSize: '.88rem', fontWeight: '700', minWidth: '24px', textAlign: 'center' }}>{cantidad}</span>
                                                    <button onClick={() => updateCartItem(producto.id, cantidad + 1)} disabled={producto.controlar_stock && producto.stock !== null && cantidad >= producto.stock} style={{ width: '28px', height: '28px', borderRadius: '6px', border: '1.5px solid #e2e8f0', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', opacity: (producto.controlar_stock && producto.stock !== null && cantidad >= producto.stock) ? 0.4 : 1 }}>
                                                        <Plus size={12} />
                                                    </button>
                                                </div>
                                                <div style={{ fontWeight: '700', fontSize: '.9rem', color: '#0f172a', minWidth: '70px', textAlign: 'right' }}>
                                                    {fmtMonto(redondear(Number(producto.precio) * cantidad - montoDescuento))} Bs.
                                                </div>
                                                <button onClick={() => removeFromCart(producto.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.primary }}>
                                                    <X size={14} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* COLUMNA DERECHA - Clientes / Resumen de venta */}
                <div className="pprod-side-panel" style={{ width: '420px', display: 'flex', flexDirection: 'column', margin: '16px', borderRadius: '20px', background: '#fff', border: '1.5px solid #f1f5f9', boxShadow: '0 4px 24px rgba(0,0,0,.05)', overflow: 'hidden', flexShrink: 0 }}>

                    <div style={{ display: 'flex', borderBottom: '1.5px solid #f1f5f9', flexShrink: 0 }}>
                        <button className={`ncp-tab ${activeRightTab === 'clients' ? 'active' : 'inactive'}`} onClick={() => setActiveRightTab('clients')}>
                            <Users size={15} /> Clientes
                        </button>
                        <button className={`ncp-tab ${activeRightTab === 'summary' ? 'active' : 'inactive'}`} onClick={() => setActiveRightTab('summary')}>
                            <CreditCard size={15} /> Resumen
                        </button>
                    </div>

                    <div className="ncp-scroll" style={{ flex: 1, overflowY: 'auto' }}>

                        {/* TAB CLIENTES */}
                        {activeRightTab === 'clients' && (
                            <div style={{ padding: '16px' }}>
                                <div style={{ display: 'flex', gap: '8px', marginBottom: '14px' }}>
                                    <button onClick={() => setShowClientModal(true)} title="Nuevo Cliente"
                                        style={{ width: '40px', height: '40px', borderRadius: '10px', border: 'none', background: `linear-gradient(135deg,${C.secondary},${C.secondaryDark})`, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, boxShadow: `0 2px 10px ${C.secondary}30`, transition: 'all .2s' }}
                                        onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.06)'}
                                        onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'}>
                                        <Plus size={18} />
                                    </button>
                                    <div style={{ flex: 1, position: 'relative' }}>
                                        <Search size={13} color="#94a3b8" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                                        <input type="search" aria-label="Buscar clientes" placeholder="Buscar por nombre, correo, CI/NIT o teléfono" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="ncp-input"
                                            style={{ width: '100%', padding: '9px 9px 9px 30px', borderRadius: '10px', border: '1.5px solid #e5e7eb', background: '#fafafa', fontSize: '.82rem', color: '#374151' }} />
                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {filteredClients.length > 0 ? filteredClients.map(c => (
                                        <div key={c.id} className={`ncp-client-card ${clienteId === c.id ? 'selected' : ''}`} role="group" aria-label={`Cliente ${c.usuario?`${c.usuario.first_name} ${c.usuario.last_name}`:c.id}`}>
                                            <button type="button" aria-pressed={clienteId===c.id} aria-label={`Seleccionar cliente ${c.usuario?`${c.usuario.first_name} ${c.usuario.last_name}`:c.id}`}
                                                onClick={() => { setClienteId(c.id); setActiveRightTab('summary'); }}
                                                style={{ display: 'flex', width:'100%', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '8px', padding:0, border:0, background:'transparent', textAlign:'left', cursor:'pointer' }}>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <p style={{ fontSize: '.85rem', fontWeight: '700', color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {c.usuario ? `${c.usuario.first_name} ${c.usuario.last_name}` : `Cliente #${c.id}`}
                                                    </p>
                                                    <p style={{ fontSize: '.72rem', color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {c.usuario?.email}
                                                    </p>
                                                </div>
                                                {clienteId === c.id && <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: C.secondary, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginLeft: '8px' }}><CheckCircle size={12} color="#fff" /></div>}
                                            </button>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                                                {[['CI/NIT', c.ci_nit, 'ciNit'], ['Teléfono', c.telefono, 'telefono']].map(([lbl, val]) => (
                                                    <div key={lbl} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 8px', background: '#f8fafc', borderRadius: '7px', fontSize: '.72rem' }}>
                                                        <span style={{ color: '#64748b' }}>{lbl}: <span style={{ color: '#374151', fontWeight: '600' }}>{val || '—'}</span></span>
                                                        <button type="button" aria-label={`Editar ${lbl} de ${c.usuario?`${c.usuario.first_name} ${c.usuario.last_name}`:`cliente ${c.id}`}`} onClick={() => { setClienteEditar(c); setShowClientModal(true); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: C.secondary, display: 'flex', alignItems: 'center' }}>
                                                            <SquarePen size={11} />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )) : (
                                        <div style={{ textAlign: 'center', padding: '32px 16px', background: '#f8fafc', borderRadius: '14px' }}>
                                            <Users size={32} color="#cbd5e1" style={{ margin: '0 auto 8px' }} />
                                            <p style={{ fontSize: '.82rem', color: '#94a3b8' }}>No se encontraron clientes</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* TAB RESUMEN */}
                        {activeRightTab === 'summary' && (
                            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>

                                {/* Cliente seleccionado (opcional) */}
                                {clienteId ? (() => {
                                    const cl = clientes.find(c => c.id === clienteId);
                                    return (
                                        <div style={{ background: `${C.secondary}08`, border: `1.5px solid ${C.secondary}20`, borderRadius: '14px', padding: '14px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                <span style={{ fontSize: '.72rem', fontWeight: '800', color: C.secondary, textTransform: 'uppercase', letterSpacing: '.06em' }}>Cliente</span>
                                                <button onClick={() => setActiveRightTab('clients')} style={{ fontSize: '.72rem', fontWeight: '700', color: C.secondary, background: 'none', border: 'none', cursor: 'pointer' }}>Cambiar</button>
                                            </div>
                                            <p style={{ fontSize: '.95rem', fontWeight: '800', color: '#0f172a', marginBottom: '8px' }}>{cl?.usuario ? `${cl.usuario.first_name} ${cl.usuario.last_name}` : `Cliente #${clienteId}`}</p>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                                                {[['CI/NIT', cl?.ci_nit], ['Teléfono', cl?.telefono]].map(([l, v]) => (
                                                    <div key={l} style={{ background: 'rgba(255,255,255,.7)', borderRadius: '8px', padding: '6px 8px' }}>
                                                        <p style={{ fontSize: '.65rem', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '.04em' }}>{l}</p>
                                                        <p style={{ fontSize: '.82rem', fontWeight: '700', color: '#374151' }}>{v || '—'}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })() : (
                                    <div style={{ background: '#f1f5f9', borderRadius: '14px', padding: '12px', textAlign: 'center' }}>
                                        <p style={{ fontSize: '.78rem', color: '#475569' }}>No se ha seleccionado un cliente. Puede continuar sin cliente.</p>
                                        <button onClick={() => setActiveRightTab('clients')} style={{ marginTop: '8px', fontSize: '.7rem', fontWeight: '600', color: C.secondary, background: 'none', border: 'none', cursor: 'pointer' }}>Seleccionar cliente</button>
                                    </div>
                                )}

                                {/* Tipo de comprobante: Factura / Recibo */}
                                <div style={{ background: '#f8fafc', borderRadius: '14px', padding: '14px' }}>
                                    <p style={{ fontSize: '.72rem', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '10px' }}>Tipo de comprobante</p>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <button
                                            onClick={() => setTipoComprobante('factura')}
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '6px',
                                                padding: '8px',
                                                borderRadius: '40px',
                                                border: `1.5px solid ${tipoComprobante === 'factura' ? C.secondary : '#e2e8f0'}`,
                                                background: tipoComprobante === 'factura' ? `${C.secondary}10` : '#fff',
                                                color: tipoComprobante === 'factura' ? C.secondary : '#64748b',
                                                fontWeight: '700',
                                                fontSize: '.8rem',
                                                cursor: 'pointer',
                                                transition: 'all .2s'
                                            }}
                                        >
                                            <FileText size={14} /> Factura
                                        </button>
                                        <button
                                            onClick={() => setTipoComprobante('recibo')}
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '6px',
                                                padding: '8px',
                                                borderRadius: '40px',
                                                border: `1.5px solid ${tipoComprobante === 'recibo' ? C.secondary : '#e2e8f0'}`,
                                                background: tipoComprobante === 'recibo' ? `${C.secondary}10` : '#fff',
                                                color: tipoComprobante === 'recibo' ? C.secondary : '#64748b',
                                                fontWeight: '700',
                                                fontSize: '.8rem',
                                                cursor: 'pointer',
                                                transition: 'all .2s'
                                            }}
                                        >
                                            <Receipt size={14} /> Recibo
                                        </button>
                                    </div>
                                </div>

                                {/* Resumen de venta */}
                                <div style={{ background: '#f8fafc', borderRadius: '14px', padding: '14px' }}>
                                    <p style={{ fontSize: '.72rem', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '8px' }}>Resumen de venta</p>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}><span>Subtotal bruto</span><strong>{fmtMonto(subtotalBruto)} Bs.</strong></div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}><span>Descuentos de línea</span><strong>{fmtMonto(descuentoLineas)} Bs.</strong></div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f1f5f9' }}>
                                        <span style={{ fontSize: '.82rem', color: '#64748b' }}>Subtotal neto</span>
                                        <span style={{ fontSize: '.9rem', fontWeight: '800' }}>{fmtMonto(subtotal)} Bs.</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f1f5f9' }}>
                                        <span style={{ fontSize: '.82rem', color: '#64748b' }}>Descuento adicional</span>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                aria-label="Descuento adicional"
                                                max={subtotal}
                                                disabled={cobrando}
                                                value={descuentoDirecto === '' ? '' : descuentoNum}
                                                onChange={handleDescuentoChange}
                                                onBlur={handleDescuentoBlur}
                                                className="ncp-input"
                                                style={{ width: '80px', textAlign: 'right', padding: '4px 8px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#fff', fontSize: '.85rem' }}
                                            />
                                            <span style={{ fontSize: '.72rem', color: '#94a3b8' }}>Bs.</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px', borderTop: '2px solid #f1f5f9', marginTop: '6px' }}>
                                        <span style={{ fontSize: '.9rem', fontWeight: '800', color: '#0f172a' }}>Total</span>
                                        <span style={{ fontSize: '1.3rem', fontWeight: '900', color: C.secondary }}>{fmtMonto(total)} Bs.</span>
                                    </div>
                                </div>

                                {/* Botón de pago */}
                                <div style={{ background: '#f8fafc', borderRadius: '14px', padding: '14px' }}>
                                    <p style={{ fontSize: '.72rem', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <CreditCard size={12} /> Pago
                                    </p>
                                    <div style={{ textAlign: 'center', padding: '12px 0' }}>
                                        <p style={{ fontSize: '.85rem', color: '#94a3b8', marginBottom: '6px' }}>Total: <strong style={{ color: C.secondary, fontSize: '1.2rem' }}>{fmtMonto(total)} Bs.</strong></p>
                                        <button
                                            onClick={() => { if (!cobrandoRef.current) setShowPagoModal(true); }}
                                            aria-busy={cobrando}
                                            disabled={cobrando || !isReadyToSell || !operadorToken}
                                            title={!operadorToken ? 'Identifica al operador de caja con su PIN para cobrar' : undefined}
                                            className={`ncp-confirm-btn ${!cobrando && isReadyToSell && operadorToken ? 'ready' : 'disabled'}`}
                                            style={{ width: '100%' }}
                                        >
                                            {cobrando ? <Loader2 size={14} style={{ animation: 'ncpSpin .7s linear infinite' }} /> : <CreditCard size={14} />} {cobrando ? 'Procesando pago…' : 'Cobrar venta'}
                                        </button>
                                        {!operadorToken ? (
                                            <p role="note" style={{ fontSize: '.68rem', color: '#92400e', fontWeight: 700, marginTop: '6px' }}>
                                                Identifica al operador de caja (PIN) en la barra del POS para cobrar.
                                            </p>
                                        ) : !isReadyToSell && (
                                            <p style={{ fontSize: '.68rem', color: '#94a3b8', marginTop: '6px' }}>
                                                Agrega productos al carrito
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ padding: '14px', borderTop: '1.5px solid #f1f5f9', flexShrink: 0 }}>
                        <p style={{ textAlign: 'center', fontSize: '.7rem', color: '#94a3b8' }}>
                            Punto de venta: {puntoDeVenta?.nombre || ''}
                        </p>
                    </div>
                </div>
            </div>

            {/* Modales */}
            {showClientModal && puntoDeVenta && <ClientePOSModal
                key={`${puntoDeVenta.id}:${clienteEditar?.id || 'nuevo'}`}
                cliente={clienteEditar || undefined} posId={puntoDeVenta.id}
                onClose={() => { setShowClientModal(false); setClienteEditar(null); }}
                onSaved={handleClienteGuardado}
            />}

            {/* Modal de éxito con botón "Seguir vendiendo" */}
            <Modal isOpen={showSuccessModal} onClose={handleSuccessModalClose} size="md">
                <div style={{ textAlign: 'center', padding: '32px 24px', fontFamily: "'DM Sans', sans-serif" }}>
                    <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: `${C.secondaryLight}18`, border: `2px solid ${C.secondaryLight}30`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                        <CheckCircle size={28} color={C.secondaryLight} />
                    </div>
                    <h3 style={{ fontSize: '1.2rem', fontWeight: '900', color: '#0f172a', marginBottom: '6px' }}>¡Venta registrada!</h3>
                    <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', marginBottom: '12px' }}>
                        {[C.primary, C.secondary, C.accentDark, C.secondaryLight].map((c, i) => (
                            <div key={i} style={{ height: '2px', width: i === 0 ? '18px' : '6px', borderRadius: '2px', background: c }} />
                        ))}
                    </div>
                    <p style={{ fontSize: '.88rem', color: '#64748b', marginBottom: '20px' }}>
                        La venta ha sido procesada correctamente.
                    </p>
                    {ventaCreada && <div style={{ textAlign: 'left', marginBottom: 20 }}>
                        <Link to={`/ventas/detalle/${ventaCreada.id}`} className="text-[#007FC8] font-bold">Ver detalle de {ventaCreada.codigo || `venta #${ventaCreada.id}`} →</Link>
                        {ventaCreada.tipo_comprobante === 'factura' && <FacturaCafeteria venta={ventaCreada} operadorToken={operadorToken} />}
                    </div>}
                    <button
                        onClick={handleSuccessModalClose}
                        style={{
                            padding: '10px 28px',
                            borderRadius: '11px',
                            border: 'none',
                            background: `linear-gradient(135deg, ${C.secondary}, ${C.secondaryDark})`,
                            color: '#fff',
                            fontWeight: '800',
                            fontSize: '.88rem',
                            cursor: 'pointer',
                            boxShadow: `0 4px 14px ${C.secondary}30`
                        }}
                    >
                        Seguir vendiendo
                    </button>
                </div>
            </Modal>

            <ModalPagoCafeteria
                isOpen={showPagoModal}
                onClose={() => setShowPagoModal(false)}
                totalVenta={total}
                tiposPago={tiposPago}
                onConfirmPago={handlePagoConfirmado}
            />
            <ExpiredSessionModal isOpen={isSessionExpired} onClose={async () => { setIsSessionExpired(false); await logout(); }} />
        </>
    );
};

export default PuntoDeVentaProducto;

